import { render } from "./ContactsBanner.vue?vue&type=template&id=b48b8ff6&scoped=true"
import script from "./ContactsBanner.vue?vue&type=script&lang=js"
export * from "./ContactsBanner.vue?vue&type=script&lang=js"

import "./ContactsBanner.vue?vue&type=style&index=0&id=b48b8ff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b48b8ff6"]])

export default __exports__